import React from "react";
import { Field } from "redux-form";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import "./styles.scss";
import { Translate } from "react-localize-redux";

const HOME = "Home";
const WORK = "Work";
const MOBILE = "Mobile";
const CUSTOM = "Custom";
const CATEGORY_CHOICES = [HOME, WORK, MOBILE];

export class CustomCategoryDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      categoryOptions: [
        { value: HOME, text: <Translate id="Home" /> },
        { value: WORK, text: <Translate id="Work" /> },
        { value: MOBILE, text: <Translate id="Mobile" /> },
        { value: CUSTOM, text: <Translate id="Custom" /> }
      ]
    };
  }

  renderDropdownItems(onChange) {
    return this.state.categoryOptions.map(option => (
      <DropdownItem key={option.value} onClick={() => onChange(option.value)}>
        {option.text}
      </DropdownItem>
    ));
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const {
      input: { value, onChange }
    } = this.props;

    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle
          caret={CATEGORY_CHOICES.includes(value)}
          className="category-dropdown-toggle"
        >
          {!CATEGORY_CHOICES.includes(value) ? (
            <input
              className="custom-category-input"
              type="text"
              value={value}
              maxLength={12}
              onChange={e => onChange(e.target.value)}
            />
          ) : (
            <span>
              <Translate id={value} />
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu className="privacy-dropdown-menu">
          {this.renderDropdownItems(onChange)}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const CatgoryDropdown = props => (
  <Field
    label={props.selectLabel}
    name={props.selectName}
    type="text"
    component={CustomCategoryDropdown}
  />
);

export default CatgoryDropdown;



// WEBPACK FOOTER //
// ./src/components/forms/CategoryDropdown/CatgoryDropdown.jsx